import * as React from 'react';
import Swal from 'sweetalert2';
import { jaxa } from '../../App';
import { useTheme } from '@emotion/react';
import { ClientSearch } from '../../components';
import { Close as CloseIcon } from '@mui/icons-material';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider, DatePicker } from '@mui/x-date-pickers';
import { Button, Dialog, List,  AppBar, Toolbar, IconButton, Typography, Slide, OutlinedInput, FormControl, ListItem, FormLabel, Box, Select, MenuItem, Backdrop, CircularProgress, useMediaQuery } from '@mui/material';

const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />;
});

const CreateProject = ({open, handleClose}) => {

    const theme = useTheme();
    const fullScreen = useMediaQuery(theme.breakpoints.down('md'));

    const foreign = React.useRef({
        clientId: null, 
        empId: null, 
    });

    const [loading, setLoading] = React.useState(false);

    const handleSubmit = async(e) => {
        e.preventDefault();
        const data = new FormData(e.currentTarget);
        const params = {
            name: data.get('pname'),
            projectCode: Date.now().toString(), 
            startDate: data.get('sdate'), 
            status: data.get('status'), 
            projectDesc: data.get('pdesc'), 
            clientId: foreign.current.clientId, 
            empId: foreign.current.empId, 
        };
        setLoading(true);
        await jaxa.post('/create-project', params).then((e) => {
            Swal.fire({ title: 'Project was created' });
        }).catch((e) => {
            Swal.fire({ title: 'Error creating project' });
            console.log(`Error: ${e}`);
        });
        setLoading(false);
        handleClose();
    };

    const loader = React.useMemo(() => (
        <Backdrop open>
            <CircularProgress />
        </Backdrop>
    ), []);

    return (

        <Dialog fullScreen={fullScreen} open={open} onClose={handleClose} TransitionComponent={Transition}>
            <AppBar sx={{ position: 'relative' }}>
                <Toolbar>
                    <IconButton
                    edge="start"
                    color="inherit"
                    onClick={handleClose}
                    aria-label="close">
                    <CloseIcon />
                    </IconButton>
                    <Typography sx={{ ml: 2, flex: 1 }} variant="h6" component="div">Create Project</Typography>
                </Toolbar>
            </AppBar>
            <Box component="form" onSubmit={handleSubmit} sx={{ display: 'flex', flexDirection: 'column', width: '100%' }}>
                <List>
                    <ListItem  sx={{ justifyContent: 'space-between', flexDirection: { xs: 'column', md: 'row' } }}>
                        <FormControl>
                            <FormLabel htmlFor="pname">Project Name</FormLabel>
                            <OutlinedInput  required margin="dense" id="pname" name="pname" label="Project Name" placeholder="Project Name" type="text" fullWidth inputProps={{ maxLength: 50 }}/>
                        </FormControl>
                    </ListItem>
                    <ListItem  sx={{ justifyContent: 'space-between', flexDirection: { xs: 'column', md: 'row' } }}>
                        <ClientSearch type='client' label='Client' placeholder='Select Clients' onChange={(id) => foreign.current.clientId = id}/>
                        <ClientSearch type='employee' label='Supervisor' placeholder='Select Employees' onChange={(id) => foreign.current.empId = id}/>
                    </ListItem>
                    <ListItem  sx={{ justifyContent: 'space-between', flexDirection: { xs: 'column', md: 'row' } }}>
                        <FormControl>
                            <FormLabel htmlFor="status">Status</FormLabel>
                            <Select required id='status' name='status' label='Status'>
                                <MenuItem value='active'>Ongoing</MenuItem>
                                <MenuItem value='completed'>Completed</MenuItem>
                                <MenuItem value='pending'>Upcoming</MenuItem>
                            </Select>
                        </FormControl>
                        <FormControl>
                            <FormLabel htmlFor="sdate">Start Date</FormLabel>
                            <LocalizationProvider dateAdapter={AdapterDayjs}>
                                <DatePicker required id='sdate' name='sdate' slotProps={{ textField: { required: true } }}/>
                            </LocalizationProvider>
                        </FormControl>
                    </ListItem>
                    <ListItem>
                        <FormControl fullWidth>
                            <FormLabel htmlFor="pdesc">Project Description</FormLabel>
                            <OutlinedInput multiline  required margin="dense" id="pdesc" name="pdesc" label="Project Description" placeholder="Project Description" type="text" fullWidth inputProps={{ maxLength: 200 }}/>
                        </FormControl>
                    </ListItem>
                </List>
                <Button type='submit' color="inherit" variant='outlined' sx={{ m: 2 }} disabled={loading}>CREATE</Button>
            </Box>
            {loading ? loader : null}
        </Dialog>

    );

};

export default React.memo(CreateProject);